import script from "./pr-po-view.vue?vue&type=script&setup=true&lang=js"
export * from "./pr-po-view.vue?vue&type=script&setup=true&lang=js"

import "./pr-po-view.vue?vue&type=style&index=0&id=06a03c76&lang=css"

const __exports__ = script;

export default __exports__